const fontBold = {
    fontWeight: 'bold',
    borderTop: '1px solid #ccc'
}

const backTR = {
    backgroundColor: '#cccccc',
}

const TabelaDescargaEnviada = ({formatMoney, relatorio, resumo}) => {
    // Não mostra se não tem dados ou se está zerado
    if (!relatorio || relatorio.length === 0) {
        return null;
    }

    // Não mostra se o resumo está zerado (sem entrada e sem apostas)
    if (!resumo || (resumo.entrada === 0 && resumo.apostas === 0)) {
        return null;
    }

    return (
        <>
            <div style={{border: '1px solid #ccc'}}>
                <table className="table table_descarga_enviada">
                    <tr style={{backgroundColor: '#FF9800', color: '#fff'}}>
                        <th className="titulo" colSpan="8">
                            Descarga Enviada
                        </th>
                    </tr>
                    <tr style={backTR}>
                        <td style={fontBold}>Banca</td>
                        <td style={fontBold}>Qtd.</td>
                        <td style={fontBold}>Entrada</td>
                        <td style={fontBold}>Saída</td>
                        <td style={fontBold}>Comissão</td>
                        <td style={fontBold}>Lançamentos</td>
                        <td style={fontBold}>Saldo</td>
                        <td style={fontBold}>Saldo Banca</td>
                    </tr>
                    <tbody>
                        {relatorio?.map((item) => (
                            <tr key={item.banca_destino_id}>
                                <td>{item.banca_destino}</td>
                                <td>{item.apostas}</td>
                                <td>{formatMoney(item.entrada)}</td>
                                <td>{formatMoney(item.saida)}</td>
                                <td>{formatMoney(item.comissao)}</td>
                                <td>{formatMoney(item.lancamento)}</td>
                                <td>
                                    <b
                                        className={`${
                                            item.total_cambista > 0 ? 'text-success' : ''
                                        } ${item.total_cambista < 0 ? 'text-danger' : ''}`}
                                    >
                                        {formatMoney(item.total_cambista)}
                                    </b>
                                </td>
                                <td>
                                    <b
                                        className={`${
                                            item.total_banca > 0 ? 'text-success' : ''
                                        } ${item.total_banca < 0 ? 'text-danger' : ''}`}
                                    >
                                        {formatMoney(item.total_banca)}
                                    </b>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default TabelaDescargaEnviada;
